import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD
};

export default new Vuex.Store({
  state: {
    site: [],
    home: [],
    about: [],
    program: [],
    teaching: [],
    visiting: [],
    activities: [],
    contact: []
  },
  getters: {
    getSemesterByUID: state => (uid, collection = state.teaching.semesters) => {
      let i = collection.length;
      while (i--) {
        if (collection[i].uid === uid) {
          return collection[i];
        }
      }
    },
    getCoursesByUID: state => (uid, collection = state.teaching.semesters) => {
      let i = collection.length;
      let courses = [];
      while (i--) {
        for (var c = 0; c < collection[i].courses.length; c++) {
          let course = collection[i].courses[c];
          for (var f = 0; f < course.faculty.length; f++) {
            if (course.faculty[f].uid === uid) {
              courses.push(course);
            }
          }
        }
      }
      return courses;
    },
    getTeamByUID: state => (uid, collection = state.visiting.teams) => {
      let i = collection.length;
      while (i--) {
        if (collection[i].uid === uid) {
          return collection[i];
        }
      }
    }
  },
  actions: {
    async loadSite({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "site",
            select: {
              title: true,
              subtitle: true,
              url: true,
              pages: {
                query: "site.pages.listed",
                select: {
                  title: true,
                  uid: true,
                  subpages: {
                    query: "page.children.listed",
                    select: {
                      title: true,
                      uid: true
                    }
                  }
                }
              }
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_SITE", response.data.result);
        });
    },
    async loadHome({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('home')",
            select: {
              title: true,
              uid: true,
              text: "page.text",
              news: {
                query: "page.children.listed.sortBy('startdate', 'asc')",
                select: {
                  title: true,
                  uid: true,
                  template: "page.intendedTemplate",
                  startdate: "page.startdate",
                  enddate: "page.enddate",
                  category: true,
                  subtitle: "page.subtitle",
                  location: "page.location.kirbytext",
                  locationlink: "page.locationlink",
                  description: "page.description.kirbytext",
                  video: "page.video",
                  image: {
                    query: "page.images.sortBy('sort')",
                    select: {
                      url: "file.url",
                      caption: "file.caption.kirbytext"
                    }
                  }
                }
              }
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_HOME", response.data.result);
        });
    },
    async loadTeaching({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('teaching')",
            select: {
              title: true,
              uid: true,
              text: "page.text",
              semesters: {
                query: "page('teaching').children.listed",
                select: {
                  title: true,
                  uid: true,
                  courses: {
                    query: "page.children.listed",
                    select: {
                      title: true,
                      uid: true,
                      group: true,
                      category: true,
                      points: true,
                      description: "page.description.kirbytext",
                      datetype: "page.datetype",
                      date: "page.date",
                      day: "page.day",
                      semester: "page.parent.title",
                      starttime: "page.starttime",
                      endtime: "page.endtime",
                      startdate: "page.startdate.toDate('l jS F Y H:i')",
                      enddate: "page.enddate",
                      interval: {
                        query: "page.interval.toStructure",
                        select: {
                          startdate: "structureItem.startdate.toDate('j F')",
                          enddate: "structureItem.enddate.toDate('j F Y')"
                        }
                      },
                      image: {
                        query: "page.images.limit(1)",
                        select: {
                          url: "file.resize(600).url",
                          thumb: "file.resize(100).url",
                          caption: "file.caption.kirbytext"
                        }
                      },
                      faculty: {
                        query: "page.faculty.toPages(',')",
                        select: {
                          title: true,
                          uid: true,
                          biography: "page.biography.kirbytext",
                          portrait: {
                            query: "page.images.limit(1)",
                            select: {
                              url: "file.resize(600).url",
                              thumb: "file.resize(100).url"
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_TEACHING", response.data.result);
        });
    },
    async loadVisiting({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('faculty')",
            select: {
              title: true,
              uid: true,
              text: "page.text",
              teams: {
                query: "page.children.listed",
                select: {
                  title: true,
                  uid: true,
                  faculty: {
                    query: "page.children.listed",
                    select: {
                      title: true,
                      uid: true,
                      biography: "page.biography.kirbytext",
                      courses: {
                        query: "page.courses.toPages",
                        select: {
                          title: true,
                          uid: true,
                          description: "page.description.kirbytext",
                          semester: "page.parent.title",
                          image: {
                            query: "page.images",
                            select: {
                              url: "file.resize(600).url",
                              thumb: "file.resize(100).url",
                              caption: "file.caption.kirbytext"
                            }
                          }
                        }
                      },
                      images: {
                        query: "page.images",
                        select: {
                          url: "file.resize(600).url",
                          thumb: "file.resize(100).url"
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_VISITING", response.data.result);
        });
    },
    async loadAbout({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('about')",
            select: {
              title: true,
              uid: true,
              text: "page.text"
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_ABOUT", response.data.result);
        });
    },
    async loadProgram({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('program')",
            select: {
              title: true,
              uid: true,
              text: "page.text"
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_PROGRAM", response.data.result);
        });
    },
    async loadActivities({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('activities').children.listed",
            select: {
              title: true,
              uid: true,
              description: "page.description.kirbytext",
              images: {
                query: "page.images.sortBy('sort')",
                select: {
                  url: "file.resize(1000).url",
                  thumb: "file.resize(100).url",
                  caption: "file.caption.kirbytext"
                }
              }
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_ACTIVITIES", response.data.result.data);
        });
    },
    async loadContact({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('contact')",
            select: {
              title: true,
              uid: true,
              text: "page.text"
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_CONTACT", response.data.result);
        });
    }
  },
  mutations: {
    SET_SITE(state, site) {
      state.site = site;
    },
    SET_HOME(state, pages) {
      state.home = pages;
    },
    SET_ABOUT(state, pages) {
      state.about = pages;
    },
    SET_PROGRAM(state, pages) {
      state.program = pages;
    },
    SET_TEACHING(state, pages) {
      state.teaching = pages;
    },
    SET_VISITING(state, pages) {
      state.visiting = pages;
    },
    SET_ACTIVITIES(state, pages) {
      state.activities = pages;
    },
    SET_CONTACT(state, pages) {
      state.contact = pages;
    }
  }
});
